import Button from './Button';

const ButtonSecondary = (props) => {
  var className = (props.className || '') + (props.className?.includes('secondary') ? '' : ' secondary');
  return <Button style={props.style || {}} {...props} className={className} testId={props.testId}>
    {props.children}
  </Button>
}

export default ButtonSecondary;